import script from "./DownloadApp.vue?vue&type=script&lang=ts&setup=true"
export * from "./DownloadApp.vue?vue&type=script&lang=ts&setup=true"

import "./DownloadApp.vue?vue&type=style&index=0&id=e4407422&scoped=true&lang=css"

import exportComponent from "/Users/carl/project/meta/landings/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e4407422"]])

export default __exports__